var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHashtagLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2107_25",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2107_25",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB/ElEQVR4nO3dXWqDUBRFYYeRnwm1Gae7I6pnAE3nYZH2uRhBzopZB+5juWV9GhBuzDA4juM4juM4B5hM11um8z11mf9d0/k+Tqf3nfb/7tofN6sw6neNdf462v64WRsjf+to++OmO0gEYQWJIKwgEYQVJIKwgkQQVpAIwgoSQVhBIggrSARhBYkgrCARhBUkgrCCRBBWkAjCChJBWEEiCCtIBGEFiSCsIHlWkNWnQ1zzQw22nmYR47LbxbbpNItX/mXXu1+QYn28ClL9CIJUf3hBqj+2INUfWJDqjypIvTKIT+kz6sFwebxf/rD7SsrB1tL04/P0NlBm91sbvj9uuoNEEFaQCMIKEkFYQSIIK0gEYQWJIKwgEYQVJIKwgkQQVpAIwgoSQVhBIggrSARhBYkgrCARhBUkgrCCRBBWkAjCCpJnBVn99k7X/FCD5TTPdL1tAPHLOtnpYvP7IcW7kx+/QwD/dA68BKl+BEGqP7wg1R9bkOoPLEj1RxWkXhnEB8N5Lwy/H1IsDNQPxex+a8P3x013kAjCChJBWEEiCCtIBGEFiSCsIBGEFSSCsIJEEFaQCMIKEkFYQSIIK0gEYQWJIKwgEYQVJIKwgkQQVpAIwgoSQVhBIsj20yzjlrd3wvfHzdq3nY47vb1z7Q/V4E6HOI7jOI7jOMP2+QHZQa/OTawhtAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashtagLarge);
export default __webpack_public_path__ + "static/media/hashtagLarge.846d69644f2b474a3c90a435945437f8.svg";
export { ForwardRef as ReactComponent };